
import Vue from 'vue';
import Component from 'vue-class-component';
import BaseLookup from './BaseLookup';
import TLookupSkin from './LookupSkin.vue';

@Component({
  name: 'LeadLookup',
  components: {
    TLookupSkin,
  },
})
export default class LeadLookup extends BaseLookup {
  dialogVisible = false;

  suggestionControllerName() {
    return 'Lead';
  }

  keyPrefix() {
    return 'Lead';
  }

  openDialog() {
    this.dialogVisible = true;
  }

  handleSelect(val) {
    this.addItem({
      key: val.key,
      title: val.value,
    });
  }

  linkClick(leadId, row) {
    let title = '';
    if (row.NAME.value) {
      title += `${row.NAME.value} `;
    }
    if (row.SURNAME.value) {
      title += `${row.SURNAME.value} `;
    }
    if (row.COMPANYNAME.value) {
      title += row.COMPANYNAME.value;
    }

    const item = {
      title,
      key: `${this.keyPrefix()}-${leadId}`,
    };

    this.addItem(item);
    if (!this.multipleSelection) {
      this.dialogVisible = false;
    }
  }
}
